import { useCallback, useMemo } from 'react';
import { PixType } from '../../enums';
import { getPixKeyConfirmationType } from '../../utils/pixKeyUtils';
export function usePixKeyCreationNavigation({ currentStep, selectedKeyType, keyValue, showConfirmation, protocolId, createdKey, onBackToList, handleKeyTypeSelect, handleKeyValueChange, handleValidationChange, handleInputTouched, handleNextClick, handleBackClick, handleConfirmationSuccess, handleConfirmationBack, }) {
    const shouldShowPixKeyTypeSelector = useMemo(() => currentStep === 0, [currentStep]);
    const shouldShowPixKeyInput = useMemo(() => currentStep === 1, [currentStep]);
    const shouldShowPlaceholder = useMemo(() => {
        if (currentStep === 0 && !selectedKeyType)
            return true;
        if (currentStep === 1 && !keyValue)
            return true;
        return false;
    }, [currentStep, selectedKeyType, keyValue]);
    const shouldShowConfirmation = useMemo(() => {
        return showConfirmation && protocolId && createdKey && selectedKeyType;
    }, [showConfirmation, protocolId, createdKey, selectedKeyType]);
    const getNavigationButtonsClassName = useCallback(() => {
        return 'navigationButtons';
    }, []);
    const getStepContent = useCallback(() => {
        if (shouldShowConfirmation) {
            return {
                type: 'confirmation',
                props: {
                    keyType: getPixKeyConfirmationType(selectedKeyType),
                    keyValue: createdKey,
                    onConfirm: handleConfirmationSuccess,
                    onResend: () => { },
                    disabled: false,
                    loading: false,
                },
            };
        }
        if (shouldShowPixKeyTypeSelector) {
            return {
                type: 'typeSelector',
                props: {
                    onKeyTypeSelect: handleKeyTypeSelect,
                },
            };
        }
        if (shouldShowPixKeyInput && selectedKeyType) {
            return {
                type: 'input',
                props: {
                    selectedKeyType,
                    keyValue: keyValue,
                    onKeyValueChange: handleKeyValueChange,
                    onValidationChange: handleValidationChange,
                    onInputTouched: handleInputTouched,
                },
            };
        }
        if (currentStep === 2) {
            if (selectedKeyType === PixType.EMAIL || selectedKeyType === PixType.PHONE) {
                return {
                    type: 'confirmation',
                    props: {
                        keyType: getPixKeyConfirmationType(selectedKeyType),
                        keyValue,
                        onConfirm: () => handleNextClick(onBackToList),
                        onResend: () => { },
                        disabled: false,
                        loading: false,
                    },
                };
            }
            return {
                type: 'placeholder',
                props: {
                    message: 'pix-keys.placeholder.confirmation-step',
                },
            };
        }
        if (shouldShowPlaceholder) {
            return {
                type: 'placeholder',
                props: {
                    message: currentStep === 0 ? 'pix-keys.placeholder.select-type' : 'pix-keys.placeholder.enter-value',
                },
            };
        }
        return {
            type: 'placeholder',
            props: {
                message: 'pix-keys.placeholder.default',
            },
        };
    }, [
        shouldShowConfirmation,
        selectedKeyType,
        createdKey,
        handleConfirmationSuccess,
        shouldShowPixKeyTypeSelector,
        handleKeyTypeSelect,
        shouldShowPixKeyInput,
        keyValue,
        handleKeyValueChange,
        handleValidationChange,
        handleInputTouched,
        currentStep,
        handleNextClick,
        onBackToList,
        shouldShowPlaceholder,
    ]);
    const handleBackButtonClick = useCallback(() => {
        if (shouldShowConfirmation) {
            handleConfirmationBack();
        }
        else {
            handleBackClick(onBackToList);
        }
    }, [shouldShowConfirmation, handleConfirmationBack, handleBackClick, onBackToList]);
    const handleNextButtonClick = useCallback(() => {
        handleNextClick(onBackToList);
    }, [handleNextClick, onBackToList]);
    return {
        shouldShowPixKeyTypeSelector,
        shouldShowPixKeyInput,
        shouldShowPlaceholder,
        shouldShowConfirmation,
        getNavigationButtonsClassName,
        getStepContent,
        handleBackButtonClick,
        handleNextButtonClick,
    };
}
